import { useMemo } from "react";
import momentTZ from "moment-timezone";

import timezonesJson from "pages/shipper/RequestForm/timezones.json";
import { getTimezoneOffset } from "helpers/dateTimeHelper";

export type TimezoneSelectOption = {
  id: number;
  value: string;
  label: string;
  optgroup: string;
};

function buildTimezoneLabel(value: string, staticLabel: string): string {
  if (!value || !momentTZ.tz.zone(value)) {
    return staticLabel;
  }
  const baseName = staticLabel.includes(" (") ? staticLabel.split(" (")[0] : staticLabel;
  return `${baseName} (${getTimezoneOffset(value)})`;
}

/**
 * Sorted IANA timezone options for selects, with labels showing the current UTC offset
 * (DST-aware via moment-timezone / getTimezoneOffset).
 */
function useTimezoneSelectOptions(): TimezoneSelectOption[] {
  return useMemo(
    () =>
      [...timezonesJson]
        .map((tz) => ({
          ...tz,
          label: buildTimezoneLabel(tz.value, tz.label),
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [],
  );
}

export default useTimezoneSelectOptions;
